const caseStudyData = {

  "mudras-against-cancer": {

    badge: "PRESS FEATURE",

    title: "Mudras Against Cancer",

    description:
      "We conducted an exclusive interview with Odissi dancer and cancer survivor Shubhada Varadkar and featured her inspiring story in WeCanServe Magazine.",

    person: "Shubhada Varadkar",

    role: "Odissi Dancer & Cancer Survivor",

    publication: "WeCanServe Magazine",

    issue: "May 2019 Issue",

    heroImages: [

      "/case-studies/mudras_against_cancer/mudras_against_cancer_page_1.png",

      "/case-studies/mudras_against_cancer/mudras_against_cancer_page_2.png"

    ],

    quote:
      "There is no shortcut. You cannot escape the treatment. Listen to everything your doctors say. If you approach treatment with a positive attitude, it will definitely have better results.",

    author: "Shubhada Varadkar",

    process: [

      {
        title: "Interview Conducted",

        desc:
          "We conducted an exclusive one-on-one interview to understand her journey, struggles and message."
      },

      {
        title: "Content Creation",

        desc:
          "Our editorial team crafted a powerful story highlighting her inspiration and impact."
      },

      {
        title: "Magazine Feature",

        desc:
          "Published as a featured story in WeCanServe Magazine."
      },

      {
        title: "Audience Impact",

        desc:
          "The feature amplified her message and created strong audience resonance."
      }

    ],

    impacts: [

      "Increased visibility through premium publication",

      "Emotional storytelling that resonated with readers",

      "Strong credibility through editorial media coverage"

    ]

  },

  "rolling-with-the-punches": {

    badge: "PRESS FEATURE",

    title: "Rolling With The Punches",

    description:
      "An inspiring editorial feature on legendary Indian boxer Ngangom Dingko Singh and his courageous battle against cancer.",

    person: "Ngangom Dingko Singh",

    role: "Indian Boxer & Cancer Survivor",

    publication: "WeCanServe Magazine",

    issue: "January 2019 Issue",

    heroImages: [

      "/case-studies/rolling_with_the_punches/rolling_with_the_punches_page_1.png",

      "/case-studies/rolling_with_the_punches/rolling_with_the_punches_page_2.png"

    ],

    quote:
      "The story highlighted resilience, courage and the fighting spirit of a national sports icon.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Feature Planning",

        desc:
          "We identified an inspiring survivor story with strong emotional and motivational value."
      },

      {
        title: "Editorial Development",

        desc:
          "Our editorial team crafted a compelling feature around resilience and recovery."
      },

      {
        title: "Magazine Publication",

        desc:
          "The story was professionally published in WeCanServe Magazine."
      },

      {
        title: "Reader Engagement",

        desc:
          "The article created emotional audience resonance and awareness."
      }

    ],

    impacts: [

      "Created strong emotional engagement among readers",

      "Strengthened inspirational storytelling credibility",

      "Enhanced audience connection through authentic narratives"

    ]

  },

  "decoding-the-numbers": {

    badge: "COMPANY FEATURE",

    title: "Decoding The Numbers",

    description:
      "A healthcare innovation feature covering SigTuple and its AI-driven approach to medical diagnostics and healthcare technology.",

    person: "SigTuple",

    role: "Healthcare AI Startup",

    publication: "WeCanServe Magazine",

    issue: "January 2019 Issue",

    heroImages: [

      "/case-studies/decoding_the_numbers/decoding_the_numbers_page_1.png",

      "/case-studies/decoding_the_numbers/decoding_the_numbers_page_2.png"

    ],

    quote:
      "The feature showcased how AI innovation is transforming modern healthcare diagnostics.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Research & Discovery",

        desc:
          "We researched emerging healthcare technology companies driving innovation."
      },

      {
        title: "Content Strategy",

        desc:
          "The editorial focused on simplifying healthcare AI for broader audience understanding."
      },

      {
        title: "Magazine Feature",

        desc:
          "The startup story was professionally published as a healthcare innovation feature."
      },

      {
        title: "Brand Positioning",

        desc:
          "The article strengthened authority and visibility around healthcare innovation."
      }

    ],

    impacts: [

      "Improved visibility for healthcare innovation",

      "Strengthened authority through editorial media coverage",

      "Created awareness around AI-driven healthcare solutions"

    ]

  },
  "pharmeasy-feature": {

    badge: "COMPANY FEATURE",

    title: "PharmEasy Feature",

    description:
      "A healthcare startup editorial feature focused on PharmEasy’s contribution towards accessible digital healthcare services in India.",

    person: "PharmEasy",

    role: "Healthcare Startup",

    publication: "WeCanServe Magazine",

    issue: "Magazine Feature Edition",

    heroImages: [

      "/case-studies/pharmeasy_feature/pharmeasy_feature_page_1.png",

      "/case-studies/pharmeasy_feature/pharmeasy_feature_page_2.png"

    ],

    quote:
      "Digital healthcare innovation is transforming accessibility and convenience for patients across India.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Startup Research",

        desc:
          "We identified PharmEasy as an emerging healthcare innovator with strong industry relevance."
      },

      {
        title: "Editorial Development",

        desc:
          "Our editorial team developed a startup-focused feature around healthcare accessibility."
      },

      {
        title: "Magazine Publication",

        desc:
          "The feature was professionally published in WeCanServe Magazine."
      },

      {
        title: "Brand Visibility",

        desc:
          "The article strengthened healthcare startup awareness and audience engagement."
      }

    ],

    impacts: [

      "Improved healthcare startup visibility",

      "Strengthened innovation-focused brand authority",

      "Created awareness around digital healthcare accessibility"

    ]

  },

  "brenna-huckaby-story": {

    badge: "PRESS FEATURE",

    title: "Brenna Huckaby Story",

    description:
      "An inspiring editorial feature highlighting Brenna Huckaby’s courageous journey, resilience and determination.",

    person: "Brenna Huckaby",

    role: "Cancer Survivor & Athlete",

    publication: "WeCanServe Magazine",

    issue: "Magazine Feature Edition",

    heroImages: [

      "/case-studies/brenna_huckaby_story/brenna_huckaby_story_page_1.png",

      "/case-studies/brenna_huckaby_story/brenna_huckaby_story_page_2.png"

    ],

    quote:
      "Stories of resilience and determination inspire strength and hope among readers.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Story Selection",

        desc:
          "We selected an inspiring survivor story with strong emotional and motivational value."
      },

      {
        title: "Editorial Storytelling",

        desc:
          "The content focused on resilience, courage and emotional impact."
      },

      {
        title: "Magazine Publication",

        desc:
          "The article was professionally designed and published through editorial media."
      },

      {
        title: "Audience Engagement",

        desc:
          "The feature generated emotional connection and meaningful reader engagement."
      }

    ],

    impacts: [

      "Created emotional audience resonance",

      "Strengthened inspirational storytelling authority",

      "Improved reader engagement and trust"

    ]

  },

  "global-oncology-feature": {

    badge: "ORGANIZATION FEATURE",

    title: "Global Oncology Feature",

    description:
      "An editorial feature highlighting global oncology initiatives, healthcare collaboration and cancer awareness efforts.",

    person: "Global Oncology",

    role: "Healthcare Organization",

    publication: "WeCanServe Magazine",

    issue: "Healthcare Feature Edition",

    heroImages: [

      "/case-studies/global_oncology_feature/global_oncology_feature_page_1.png",

      "/case-studies/global_oncology_feature/global_oncology_feature_page_2.png"

    ],

    quote:
      "Collaborative healthcare initiatives continue to shape the future of global oncology awareness.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Healthcare Research",

        desc:
          "We researched impactful oncology initiatives and healthcare collaborations."
      },

      {
        title: "Content Strategy",

        desc:
          "The editorial was structured around awareness, education and healthcare innovation."
      },

      {
        title: "Publication",

        desc:
          "The article was published as a healthcare organization feature."
      },

      {
        title: "Awareness Impact",

        desc:
          "The feature strengthened awareness and healthcare engagement."
      }

    ],

    impacts: [

      "Strengthened oncology awareness",

      "Improved healthcare engagement",

      "Enhanced authority through editorial media coverage"

    ]

  },

  "actrec-feature": {

    badge: "INSTITUTE FEATURE",

    title: "ACTREC Feature",

    description:
      "An institutional feature covering ACTREC’s contribution towards cancer research, innovation and healthcare advancement.",

    person: "ACTREC",

    role: "Cancer Research Institute",

    publication: "WeCanServe Magazine",

    issue: "Research Feature Edition",

    heroImages: [

      "/case-studies/actrec_feature/actrec_feature_page_1.png",

      "/case-studies/actrec_feature/actrec_feature_page_2.png"

    ],

    quote:
      "Research and innovation remain critical in advancing cancer treatment and healthcare outcomes.",

    author: "WeCanServe Editorial Team",

    process: [

      {
        title: "Institution Research",

        desc:
          "We researched ACTREC’s contribution towards cancer research and healthcare innovation."
      },

      {
        title: "Editorial Development",

        desc:
          "The feature focused on institutional authority and healthcare impact."
      },

      {
        title: "Magazine Publication",

        desc:
          "The article was professionally published through editorial media."
      },

      {
        title: "Authority Building",

        desc:
          "The feature strengthened awareness around healthcare research excellence."
      }

    ],

    impacts: [

      "Strengthened institutional credibility",

      "Improved awareness around cancer research",

      "Created authority-driven editorial presence"

    ]

  },
  "jipmer-feature": {

  badge: "HOSPITAL FEATURE",

  title: "JIPMER Feature",

  description:
    "An institutional editorial feature highlighting JIPMER’s contribution towards healthcare education, cancer care and medical research.",

  person: "JIPMER",

  role: "Medical Research & Healthcare Institute",

  publication: "WeCanServe Magazine",

  issue: "Healthcare Feature Edition",

  heroImages: [

    "/case-studies/jipmer_feature/jipmer_feature_page_1.png",

    "/case-studies/jipmer_feature/jipmer_feature_page_2.png"

  ],

  quote:
    "Healthcare education and research continue to play a vital role in advancing cancer treatment and patient care.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Institution Research",

      desc:
        "We researched JIPMER’s contribution towards healthcare excellence and medical advancement."
    },

    {
      title: "Editorial Strategy",

      desc:
        "The feature was structured around institutional authority and educational impact."
    },

    {
      title: "Magazine Publication",

      desc:
        "The institutional feature was professionally published in WeCanServe Magazine."
    },

    {
      title: "Healthcare Awareness",

      desc:
        "The article strengthened awareness around healthcare research and education."
    }

  ],

  impacts: [

    "Strengthened institutional authority",

    "Improved healthcare awareness",

    "Enhanced credibility through editorial publication"

  ]

},

"gcri-feature": {

  badge: "INSTITUTE FEATURE",

  title: "GCRI Feature",

  description:
    "A healthcare editorial feature showcasing GCRI’s efforts towards cancer research, treatment and patient care.",

  person: "GCRI",

  role: "Cancer Research Institute",

  publication: "WeCanServe Magazine",

  issue: "Healthcare Feature Edition",

  heroImages: [

    "/case-studies/gcri_feature/gcri_feature_page_1.png",

    "/case-studies/gcri_feature/gcri_feature_page_2.png"

  ],

  quote:
    "Cancer research institutions continue to shape the future of healthcare innovation and patient treatment.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Research & Analysis",

      desc:
        "We analyzed GCRI’s healthcare and cancer research contributions."
    },

    {
      title: "Editorial Development",

      desc:
        "The feature focused on institutional impact and healthcare advancement."
    },

    {
      title: "Magazine Publication",

      desc:
        "The institutional feature was published through editorial media."
    },

    {
      title: "Public Awareness",

      desc:
        "The article improved awareness around cancer research and healthcare services."
    }

  ],

  impacts: [

    "Strengthened healthcare authority",

    "Improved awareness around cancer research",

    "Created institutional editorial visibility"

  ]

},

"rajiv-gandhi-cancer-institute-feature": {

  badge: "HOSPITAL FEATURE",

  title: "Rajiv Gandhi Cancer Institute Feature",

  description:
    "An editorial feature highlighting Rajiv Gandhi Cancer Institute’s contribution towards cancer treatment, research and patient care.",

  person: "Rajiv Gandhi Cancer Institute",

  role: "Cancer Hospital & Research Institute",

  publication: "WeCanServe Magazine",

  issue: "Healthcare Institution Edition",

  heroImages: [

    "/case-studies/rgci_feature/rgci_feature_page_1.png",

    "/case-studies/rgci_feature/rgci_feature_page_2.png"

  ],

  quote:
    "Advanced healthcare institutions continue to strengthen patient care through innovation and research.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Institution Coverage",

      desc:
        "We researched the hospital’s contribution towards cancer care and treatment."
    },

    {
      title: "Editorial Planning",

      desc:
        "The feature was structured around healthcare excellence and institutional credibility."
    },

    {
      title: "Publication",

      desc:
        "The hospital feature was professionally published through editorial media."
    },

    {
      title: "Audience Engagement",

      desc:
        "The article strengthened awareness and institutional visibility."
    }

  ],

  impacts: [

    "Improved healthcare institution visibility",

    "Strengthened authority through editorial media",

    "Enhanced public awareness around cancer care"

  ]

},

"icmr-nicpr-feature": {

  badge: "RESEARCH FEATURE",

  title: "ICMR-NICPR Feature",

  description:
    "A research-focused editorial feature highlighting ICMR-NICPR’s contribution towards cancer prevention and healthcare research.",

  person: "ICMR-NICPR",

  role: "Cancer Prevention Research Institute",

  publication: "WeCanServe Magazine",

  issue: "Research Feature Edition",

  heroImages: [

    "/case-studies/icmr_nicpr_feature/icmr_nicpr_feature_page_1.png",

    "/case-studies/icmr_nicpr_feature/icmr_nicpr_feature_page_2.png"

  ],

  quote:
    "Research and prevention initiatives continue to shape the future of cancer awareness and healthcare advancement.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Research Analysis",

      desc:
        "We researched ICMR-NICPR’s healthcare and prevention initiatives."
    },

    {
      title: "Editorial Structuring",

      desc:
        "The feature focused on awareness, research and institutional impact."
    },

    {
      title: "Magazine Publication",

      desc:
        "The research feature was professionally published in editorial format."
    },

    {
      title: "Awareness Impact",

      desc:
        "The article strengthened healthcare education and awareness."
    }

  ],

  impacts: [

    "Improved awareness around cancer prevention",

    "Strengthened institutional research credibility",

    "Enhanced editorial healthcare visibility"

  ]

},

"helping-hands-foundation-feature": {

  badge: "NGO FEATURE",

  title: "Helping Hands Foundation Feature",

  description:
    "An NGO-focused editorial feature showcasing Helping Hands Foundation’s contribution towards healthcare support and social impact.",

  person: "Helping Hands Foundation",

  role: "Healthcare NGO",

  publication: "WeCanServe Magazine",

  issue: "Social Impact Edition",

  heroImages: [

    "/case-studies/helping_hands_feature/helping_hands_feature_page_1.png",

    "/case-studies/helping_hands_feature/helping_hands_feature_page_2.png"

  ],

  quote:
    "Social impact initiatives continue to create meaningful support systems for patients and communities.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "NGO Research",

      desc:
        "We researched Helping Hands Foundation’s contribution towards healthcare support initiatives."
    },

    {
      title: "Editorial Development",

      desc:
        "The content focused on social impact, awareness and community contribution."
    },

    {
      title: "Magazine Publication",

      desc:
        "The NGO feature was professionally published through editorial media."
    },

    {
      title: "Community Awareness",

      desc:
        "The article strengthened social awareness and audience engagement."
    }

  ],

  impacts: [

    "Improved NGO visibility and credibility",

    "Strengthened social impact awareness",

    "Enhanced audience engagement through editorial storytelling"

  ]

},
"shadi-ganz-foundation-feature": {

  badge: "NGO FEATURE",

  title: "Saviour On Wheels",

  description:
    "An inspiring editorial feature on Germany-born cancer survivor Shadi Ganz and her Mammomobile initiative bringing cancer screening services to rural women across Tamil Nadu.",

  person: "Shadi Ganz",

  role: "Founder, Shadi Ganz Foundation Mammomobile Charitable Trust",

  publication: "WeCanServe Magazine",

  issue: "March 2019 Issue",

  heroImages: [

    "/case-studies/shadi_ganz_foundation/shadi_ganz_foundation_page_1.png",

    "/case-studies/shadi_ganz_foundation/shadi_ganz_foundation_page_2.png"

  ],

  quote:
    "We want to expand screening services, so that more women can become survivors of breast cancer instead of victims.",

  author: "Shadi Ganz",

  process: [

    {
      title: "Story Research",

      desc:
        "We researched Shadi Ganz’s inspiring healthcare initiative focused on rural cancer screening and awareness."
    },

    {
      title: "Editorial Development",

      desc:
        "The editorial feature was crafted around awareness, survivor strength and social healthcare impact."
    },

    {
      title: "Magazine Publication",

      desc:
        "The feature was professionally published in WeCanServe Magazine."
    },

    {
      title: "Awareness Impact",

      desc:
        "The article strengthened public awareness around early cancer detection and rural healthcare accessibility."
    }

  ],

  impacts: [

    "Strengthened healthcare awareness through impactful storytelling",

    "Improved visibility for rural cancer screening initiatives",

    "Created strong emotional engagement and social credibility"

  ]

},

"wholesome-rhapsody-feature": {

  badge: "STARTUP FEATURE",

  title: "Sweet Treats",

  description:
    "A healthcare startup feature highlighting Wholesome Rhapsody and its customised desserts designed specially for cancer patients and people with medical dietary needs.",

  person: "Wholesome Rhapsody",

  role: "Healthcare Bakery Startup",

  publication: "WeCanServe Magazine",

  issue: "April 2019 Issue",

  heroImages: [

    "/case-studies/wholesome_rhapsody/wholesome_rhapsody_page_1.png",

    "/case-studies/wholesome_rhapsody/wholesome_rhapsody_page_2.png"

  ],

  quote:
    "Healthy desserts can become part of healing when science, nutrition and taste work together.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Startup Research",

      desc:
        "We researched Wholesome Rhapsody’s innovative healthcare-focused dessert concept and nutritional approach."
    },

    {
      title: "Editorial Development",

      desc:
        "The feature was structured around health-conscious baking, cancer-friendly nutrition and startup innovation."
    },

    {
      title: "Magazine Publication",

      desc:
        "The startup feature was professionally published through WeCanServe Magazine."
    },

    {
      title: "Audience Awareness",

      desc:
        "The article created awareness around therapeutic nutrition and healthcare-focused food innovation."
    }

  ],

  impacts: [

    "Improved visibility for a healthcare-focused startup",

    "Strengthened authority through editorial publication",

    "Created awareness around customised therapeutic nutrition"

  ],

},

    "zuvius-blaze-of-brilliance": {

    badge: "PRESS FEATURE",

    title: "Blaze of Brilliance",

    description:
      "A powerful editorial feature highlighting Zuvius Lifesciences’ journey from a struggling startup to a globally expanding oncology-focused pharmaceutical brand driven by innovation, resilience and purpose.",

    person: "Nimish Thakkar",

    role: "Chairman & Managing Director, Zuvius Lifesciences",

    publication: "WeCanServe Magazine",

    issue: "January 2018 Issue",

    heroImages: [
      "/case-studies/zuvius_lifesciences_pages/zuvius-lifesciences_page_18.png",
      "/case-studies/zuvius_lifesciences_pages/zuvius-lifesciences_page_19.png"
    ],

    quote:
      "We don’t want to be just another onco-pharma company. We want to redefine oncology in many thoughtful ways.",

    author: "Nimish Thakkar",

    process: [
      {
        title: "Story Identification",
        desc:
          "We identified Zuvius Lifesciences as a high-potential oncology brand with a compelling entrepreneurial journey and strong industry impact."
      },
      {
        title: "Editorial Development",
        desc:
          "The feature was crafted around resilience, innovation and the company’s mission to redefine oncology beyond just treatment."
      },
      {
        title: "Magazine Publication",
        desc:
          "The story was professionally published as a premium editorial feature in WeCanServe Magazine."
      },
      {
        title: "Audience Impact",
        desc:
          "The feature strengthened brand perception, highlighting Zuvius as a purpose-driven and fast-growing global healthcare company."
      }
    ],

    impacts: [
      "Showcased strong brand journey from struggle to success",
      "Positioned Zuvius as an innovation-driven oncology company",
      "Enhanced credibility through premium editorial coverage",
      "Highlighted global expansion and healthcare impact"
    ]

  },
"pink-street-kims-feature": {

  badge: "CAMPAIGN FEATURE",

  title: "Pink Street Campaign at KIMS",

  description:
    "A large-scale cancer awareness campaign conducted at Krishna Institute of Medical Sciences, bringing together students, doctors and the community to promote early detection and prevention.",

  person: "Dr Anand Gudur & Dr Rashmi Gudur",

  role: "Oncology Experts, Krishna Institute of Medical Sciences",

  publication: "WeCanServe Magazine",

  issue: "February 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_feb_pages_15_19/wecanserve_feb_page_15.png",
    "/case-studies/wecanserve_feb_pages_15_19/wecanserve_feb_page_16.png",
    "/case-studies/wecanserve_feb_pages_15_19/wecanserve_feb_page_17.png",
    "/case-studies/wecanserve_feb_pages_15_19/wecanserve_feb_page_18.png",
    "/case-studies/wecanserve_feb_pages_15_19/wecanserve_feb_page_19.png"
  ],

  quote:
    "Since cure rates can be significantly better if detected early, improving awareness among healthcare providers and the general public is pivotal.",

  author: "Dr Anand Gudur",

  process: [

    {
      title: "Campaign Collaboration",
      desc:
        "The institute collaborated with the Pink Street campaign to promote cancer awareness among students and future medical professionals."
    },

    {
      title: "Student Engagement",
      desc:
        "Hundreds of students and faculty from multiple medical disciplines actively participated in awareness initiatives and activities."
    },

    {
      title: "Awareness Activities",
      desc:
        "Campaign included record-setting initiatives like creating India’s largest hand-printed cancer awareness ribbon and organizing social awareness drives."
    },

    {
      title: "Community Impact",
      desc:
        "The initiative extended beyond campus through village camps, lectures, and awareness programs focused on prevention and early detection."
    }

  ],

  impacts: [

    "Engaged over 1500+ students in cancer awareness initiatives",

    "Promoted early detection and prevention education",

    "Strengthened collaboration between institutions and campaigns",

    "Created large-scale social awareness impact in rural areas",

    "Encouraged youth participation in healthcare initiatives"

  ]

},
"yoddhas-ngo-feature": {

  badge: "NGO FEATURE",

  title: "Hope… One Meal at a Time",

  description:
    "An inspiring NGO feature highlighting Yoddhas and its mission to support cancer patients through nutrition, care and community-driven initiatives.",

  person: "Yoddhas",

  role: "Cancer Support NGO",

  publication: "WeCanServe Magazine",

  issue: "August 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_sep_pages_24_25/wecanserve_sep_page_24.png",
    "/case-studies/wecanserve_sep_pages_24_25/wecanserve_sep_page_25.png"

  ],

  quote:
    "Small acts like providing a meal can bring hope and strength to patients fighting cancer.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "NGO Identification",
      desc:
        "We identified Yoddhas as a meaningful initiative focused on supporting cancer patients through basic yet impactful services like nutrition."
    },

    {
      title: "Story Development",
      desc:
        "The feature focused on how small efforts like providing meals can significantly improve patient morale and recovery."
    },

    {
      title: "Editorial Publication",
      desc:
        "The story was professionally published as an NGO feature in WeCanServe Magazine."
    },

    {
      title: "Awareness Impact",
      desc:
        "The article highlighted the importance of community-driven support systems in healthcare."
    }

  ],

  impacts: [

    "Improved awareness about patient support initiatives",
    "Highlighted importance of nutrition in recovery",
    "Strengthened NGO visibility and credibility",
    "Created emotional engagement with readers"

  ]

},
"the-happiness-trap-feature": {

  badge: "WELLNESS FEATURE",

  title: "The Happiness Trap",

  description:
    "A thought-provoking feature exploring how the constant pursuit of happiness can lead to stress, and how acceptance and mindfulness can improve mental well-being.",

  person: "Mental Wellness Concept",

  role: "Psychological Awareness & Self-Help",

  publication: "WeCanServe Magazine",

  issue: "May 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_may_page_8/wecanserve_may_page_8.png",
    
  ],

  quote:
    "The struggle to always stay happy can become the very reason for stress and dissatisfaction.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Concept Research",
      desc:
        "We explored psychological insights around the pressure of staying constantly happy and its impact on mental health."
    },

    {
      title: "Content Development",
      desc:
        "The feature was structured around real-life emotional struggles and the importance of acceptance."
    },

    {
      title: "Editorial Publication",
      desc:
        "The article was published as a wellness-focused feature in WeCanServe Magazine."
    },

    {
      title: "Reader Impact",
      desc:
        "The feature helped readers rethink their approach towards happiness and mental well-being."
    }

  ],

  impacts: [

    "Promoted mental health awareness",
    "Encouraged acceptance over perfection",
    "Created emotional connection with readers",
    "Added depth to wellness storytelling"

  ]

},
"love-loss-and-more-feature": {

  badge: "LIFESTYLE FEATURE",

  title: "Love, Loss and More",

  description:
    "A deeply emotional feature exploring themes of love, loss and resilience, highlighting the human side of dealing with illness and personal struggles.",

  person: "Human Experience",

  role: "Emotional & Lifestyle Story",

  publication: "WeCanServe Magazine",

  issue: "June 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_june_page_52/wecanserve_june_page_52.png"
    

  ],

  quote:
    "Love and loss are deeply connected, shaping our strength and the way we move forward in life.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Story Exploration",
      desc:
        "We explored emotional narratives focusing on love, grief and personal resilience."
    },

    {
      title: "Content Development",
      desc:
        "The feature was crafted to connect emotionally with readers through relatable life experiences."
    },

    {
      title: "Editorial Publication",
      desc:
        "The article was published as a lifestyle feature in WeCanServe Magazine."
    },

    {
      title: "Audience Connection",
      desc:
        "The story created a strong emotional bond and reflection among readers."
    }

  ],

  impacts: [

    "Created emotional engagement",
    "Highlighted human resilience",
    "Strengthened storytelling depth",
    "Connected with readers on a personal level"

  ]

},
"snapchat-to-surgery-feature": {

  badge: "TECH INNOVATION",

  title: "From Snapchat Filters to Operational Theatres",

  description:
    "An innovation-driven feature exploring how augmented reality technology, popularized by Snapchat filters, is now transforming precision and efficiency in modern surgical procedures.",

  person: "Augmented Reality Technology",

  role: "Healthcare & Surgical Innovation",

  publication: "WeCanServe Magazine",

  issue: "July 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_july_pages_26_27/wecanserve_july_page_26.png",
    "/case-studies/wecanserve_july_pages_26_27/wecanserve_july_page_27.png"

  ],

  quote:
    "Technology once used for entertainment is now redefining accuracy and outcomes in healthcare.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Technology Research",
      desc:
        "We explored how augmented reality evolved from social media filters to advanced medical applications."
    },

    {
      title: "Innovation Analysis",
      desc:
        "The feature focused on AR-assisted surgeries improving precision and reducing risks."
    },

    {
      title: "Editorial Development",
      desc:
        "The article connected everyday technology with real-world healthcare advancements."
    },

    {
      title: "Impact Awareness",
      desc:
        "The feature highlighted the future potential of AR in medical science."
    }

  ],

  impacts: [

    "Showcased real-world application of AR technology",
    "Improved awareness about surgical innovation",
    "Connected technology with healthcare advancements",
    "Enhanced audience understanding of modern medical tools"

  ]

},
"rise-of-aspirin-feature": {

  badge: "HEALTHCARE FEATURE",

  title: "Rise of Aspirin",

  description:
    "A healthcare-focused feature exploring the evolution of aspirin, its medical significance and its expanding role in disease prevention and treatment.",

  person: "Aspirin",

  role: "Pharmaceutical Innovation",

  publication: "WeCanServe Magazine",

  issue: "August 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_aug_pages_31_32/wecanserve_aug_page_31.png",
    "/case-studies/wecanserve_aug_pages_31_32/wecanserve_aug_page_32.png"

  ],

  quote:
    "A simple drug like aspirin continues to play a powerful role in modern medicine and disease prevention.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Historical Research",
      desc:
        "We explored the origin and development of aspirin as one of the most widely used medicines."
    },

    {
      title: "Medical Analysis",
      desc:
        "The feature focused on aspirin’s role in pain relief, heart health and disease prevention."
    },

    {
      title: "Editorial Development",
      desc:
        "The article simplified complex medical insights for general audience understanding."
    },

    {
      title: "Awareness Impact",
      desc:
        "The feature highlighted the importance of commonly used medicines in healthcare."
    }

  ],

  impacts: [

    "Improved awareness about aspirin usage",
    "Highlighted role in disease prevention",
    "Simplified medical knowledge for readers",
    "Strengthened healthcare storytelling"

  ]

},
"heeding-signals-key-feature": {

  badge: "HEALTHCARE FEATURE",

  title: "Heeding Signals is Key",

  description:
    "An insightful editorial feature emphasizing the importance of early warning signs in cancer detection and how timely action can significantly improve survival outcomes.",

  person: "Healthcare Experts",

  role: "Doctors & Cancer Awareness Specialists",

  publication: "WeCanServe Magazine",

  issue: "October 2018 Issue",

  heroImages: [

    "/case-studies/wecanserve_oct_page_58/wecanserve_oct_page_58.png"
    

  ],

  quote:
    "Recognizing early symptoms and acting on them at the right time can save lives and improve treatment success rates.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Topic Identification",
      desc:
        "We focused on the importance of early symptom recognition in cancer diagnosis and prevention."
    },

    {
      title: "Medical Insight Research",
      desc:
        "The article was built using healthcare insights on warning signs and patient awareness."
    },

    {
      title: "Editorial Development",
      desc:
        "The content was structured to educate readers on early detection and proactive healthcare behavior."
    },

    {
      title: "Awareness Impact",
      desc:
        "The feature encouraged individuals to take symptoms seriously and seek timely medical help."
    }

  ],

  impacts: [

    "Promoted early cancer detection awareness",

    "Encouraged proactive healthcare behavior",

    "Improved public understanding of warning signs",

    "Strengthened preventive healthcare education"

  ]

},
"banish-winter-blues-feature": {

  badge: "WELLNESS FEATURE",

  title: "Banish the Winter Blues",

  description:
    "A wellness-focused editorial feature highlighting how seasonal changes can impact mental health and practical ways to overcome winter blues through lifestyle and awareness.",

  person: "Healthcare & Wellness Experts",

  role: "Mental Health & Lifestyle Specialists",

  publication: "WeCanServe Magazine",

  issue: "November 2018 Issue",

  heroImages: [

    "/case-studies/page_54_extract/nov 2018.png"
    
  ],

  quote:
    "Simple lifestyle changes and awareness can help individuals overcome seasonal mood changes and maintain emotional well-being.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Topic Selection",
      desc:
        "We identified seasonal mental health as an important yet often overlooked wellness topic."
    },

    {
      title: "Research & Insights",
      desc:
        "The feature explored how winter affects mood, energy levels and mental health."
    },

    {
      title: "Editorial Development",
      desc:
        "The content was structured around practical tips including diet, sunlight exposure and daily routines."
    },

    {
      title: "Awareness Impact",
      desc:
        "The article encouraged readers to take proactive steps towards maintaining mental wellness."
    }

  ],

  impacts: [

    "Promoted awareness about seasonal mental health",

    "Encouraged healthy lifestyle habits",

    "Improved understanding of mood-related changes",

    "Supported overall mental well-being awareness"

  ]

},
"village-warrior-feature": {

  badge: "SOCIAL IMPACT FEATURE",

  title: "The Village Warrior",

  description:
    "An inspiring editorial feature showcasing a grassroots changemaker working at the village level to improve healthcare awareness and support cancer patients through community-driven efforts.",

  person: "Community Healthcare Advocate",

  role: "Rural Cancer Awareness Contributor",

  publication: "WeCanServe Magazine",

  issue: "December 2018 Issue",

  heroImages: [

    "/case-studies/magazines_cover_extract_page_13/page13_dec2018.png"
    

  ],

  quote:
    "Real change begins at the grassroots level, where awareness and action can transform entire communities.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Story Identification",
      desc:
        "We identified a powerful rural story highlighting individual efforts in spreading cancer awareness."
    },

    {
      title: "Field Research",
      desc:
        "The feature explored challenges faced in rural healthcare and the importance of local initiatives."
    },

    {
      title: "Editorial Development",
      desc:
        "The article was structured around awareness, social impact and community participation."
    },

    {
      title: "Impact Awareness",
      desc:
        "The story inspired readers by showcasing how one individual can influence an entire village."
    }

  ],

  impacts: [

    "Highlighted grassroots healthcare initiatives",

    "Promoted rural cancer awareness",

    "Encouraged community participation",

    "Strengthened social impact storytelling"

  ]

},
"a-healthy-future-feature": {

  badge: "HEALTHCARE FEATURE",

  title: "A Healthy Future",

  description:
    "A forward-looking editorial feature focusing on the importance of preventive healthcare, early diagnosis and lifestyle changes in building a healthier future.",

  person: "Healthcare Experts",

  role: "Doctors & Preventive Care Specialists",

  publication: "WeCanServe Magazine",

  issue: "January 2017 Issue",

  heroImages: [

    "/case-studies/magazines_cover_extract_page_20/page20_december_2017.png"
    

  ],

  quote:
    "A healthier future depends on awareness, prevention and timely action towards our well-being.",

  author: "WeCanServe Editorial Team",

  process: [

    {
      title: "Topic Identification",
      desc:
        "We focused on preventive healthcare as a key factor in reducing disease burden."
    },

    {
      title: "Research & Insights",
      desc:
        "The feature explored lifestyle habits, early diagnosis and long-term health planning."
    },

    {
      title: "Editorial Development",
      desc:
        "The article was structured to educate readers about building sustainable health practices."
    },

    {
      title: "Awareness Impact",
      desc:
        "The feature encouraged proactive healthcare decisions and long-term wellness thinking."
    }

  ],

  impacts: [

    "Promoted preventive healthcare awareness",

    "Encouraged healthy lifestyle habits",

    "Improved understanding of early diagnosis importance",

    "Strengthened long-term wellness perspective"

  ]

},
"gut-microbiome-feature": {
  badge: "HEALTHCARE FEATURE",

  title: "Gut Microbiome",

  description:
    "A healthcare-focused feature exploring the importance of gut microbiome in overall health, immunity and disease prevention.",

  person: "Gut Microbiome",

  role: "Digestive Health & Microbial System",

  publication: "WeCanServe Magazine",

  issue: "April 2018 Issue",

  heroImages: [
    "/case-studies/wecanserve_april_page_13_gut_microbiome/wecanserve_april_page_13_gut_microbiome.png",
    
  ],

  quote:
    "A healthy gut plays a crucial role in maintaining immunity and overall well-being.",

  author: "WeCanServe Editorial Team",

  process: [
    {
      title: "Topic Research",
      desc:
        "We explored the role of gut microbiome and its importance in maintaining overall health."
    },
    {
      title: "Content Development",
      desc:
        "The feature was structured to simplify complex biological concepts for general understanding."
    },
    {
      title: "Editorial Publication",
      desc:
        "The article was published as a healthcare feature in WeCanServe Magazine."
    },

    {
      title: "Audience Awareness",
      desc:
        "The feature improved awareness about gut health and preventive healthcare."
    }
  ],

  impacts: [
    "Improved awareness about gut health",
    "Highlighted importance of microbiome balance",
    "Promoted preventive healthcare understanding"
  ]
}

};

export default caseStudyData;
